<template lang="pug">
section.appointments
    .row.pb-5
        .col-1
        .col-10.mt-5
          h4.title.text-white.text-center.text-uppercase.py-5 {{ info.title }}
        .col-1
        .col-1
        .col-10.text-primary
            .row
                .col-12.col-sm-7.text-white.pr-sm-4.font-weight-light.d-flex.align-content-around.flex-wrap {{ info.description }}
                    ol
                      li(v-for='service in info.servicesList')
                          h6.d-inline-block.font-weight-bold
                            i.check-icon.mr-3
                            template {{ service }}
                    .text-left
                      i.calendar-icon.mr-3
                      template {{ info.days }}
                      br
                      i.clock-icon.mr-3
                      template {{ info.hours }}
                      br
                      i.location-icon.mr-3
                      template {{ info.place }}
                .col-12.col-sm-5.mt-4.mt-sm-0
                  .form-container.bg-white.rounded.pt-4.pl-4.pr-4.pb-1.ml-sm-4
                      .form-group
                        label(for='name') {{form.name.label }}
                        .input-group
                          input#name.form-control.form-control-sm(v-model='form.name.value' type='text', name='name', :placeholder='form.name.placeholder', required='')
                          .input-group-append
                            span#date.input-group-text.text-secondary
                              i.fa.fa-user
                      .form-row
                        .form-group.col-sm-6
                          label(for='email') {{ form.email.label }}
                          .input-group
                            input#email.form-control.form-control-sm(v-model='form.email.value' type='email', name='email', :placeholder='form.email.placeholder', required='')
                            .input-group-append
                              span#date.input-group-text.text-secondary
                                i.fa.fa-envelope
                        .form-group.col-sm-6
                          label(for='phone') {{ form.phone.label }}
                          .input-group
                            input#phone.form-control.form-control-sm(v-model='form.phone.value' type='number', name='phone', :placeholder='form.phone.placeholder')
                            .input-group-append
                              span#date.input-group-text.text-secondary
                                i.fa.fa-phone
                      .form-row
                        .form-group.col-sm-7
                          label.mr-sm-2(for='type') {{ form.type.label }}
                          select#type.form-control.form-control-sm(v-model='form.type.value' name='type', required='')
                            option(value='0') {{ form.type.placeholder }}
                            option(v-for='(op,i) in form.type.selectOptions' :value='i+1') {{ op }}
                        .form-group.col-sm-5
                          label.mr-sm-2(for='date') {{ form.day.label }}
                          .input-group
                            flat-pickr#date.calendar.form-control.form-control-sm(v-model='form.day.value' :config='form.day.config' name='date',  :placeholder='form.day.placeholder',)
                            .input-group-append
                              span#date.input-group-text.text-secondary
                                i.fa.fa-calendar
                      
                      .form-group
                        label(for='message') {{ form.message.label }}
                        textarea#message.form-control.form-control-sm(v-model='form.message.value' name='message', rows='2', :placeholder='form.message.placeholder')

                      .form-group.text-right
                        button.submit.btn.btn-secondary.btn-block(type='submit' @click='send()' :disable='form.button.showLoading')
                          template {{ form.button.text }} 
                          i.fa.fa-spinner.fa-pulse.fa-fw(v-show='form.button.showLoading')
        .col-1
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { Spanish } from "flatpickr/dist/l10n/es.js"
import 'flatpickr/dist/flatpickr.css';
import emailService from '@/ws/email'
import MODAL from '@/constants/modal-types'

export default {
    components: {
      flatPickr
    },
    methods:{
      send() {
        this.form.button.showLoading = true
        emailService.appointment({
          name: this.form.name.value,
          email: this.form.email.value,
          phone: this.form.phone.value,
          type: this.form.type.value,
          day: this.form.day.value,
          message: this.form.message.value,
        }).then(res => {
            this.handlerRes(res)
        })
      },
      handlerRes(res) {
        console.log(res)
        if (res.success) {
          this.clearForm()
          this.$bus.$emit('show', this.form.modalSuccess)
        } else {
          let keysReturned = Object.keys(res.errors)
          if (keysReturned.length === 1)
             this.form.modalFailure.message = res.errors[keysReturned[0]]

          this.form.button.showLoading = false
          this.$bus.$emit('show', this.form.modalFailure)
        }
      },
      clearForm() {
        this.form.name.value = ''
        this.form.email.value = ''
        this.form.phone.value = ''
        this.form.type.value = ''
        this.form.day.value = ''
        this.form.message.value = ''

        this.form.button.showLoading = false
      }
    },
    data () {
        return {
          info: {
            title: 'Consultas',
            description: 'Te brindamos los siguientes consultas, agenda tu cita y mejorar tu calidad de vida ¡HOY!',
            servicesList: [
                'Consulta de Ortografía Cerebral',
                'Desbloqueo emocional y financiero',
                'Sesión de lectura del inconsciente y alineación cerebral con cuarzos'
            ],
            days: 'Martes, miércoles y jueves',
            hours: '10:00 am a 5:00 pm',
            place: 'Ciudad satélite, CDMX',
          },
          form: {
            modalSuccess: {
              type: MODAL.DIALOG,
              title: '¡Felicidades!',
              message: 'Tu solicitud ha sido enviada con éxito, en breve nos comunicaremos contigo para confimar tu cita.',
              close: 'Cerrar'
            },
            modalFailure: {
              type: MODAL.DIALOG,
              title: 'Esta a un paso de enviarnos tu mensaje...',
              message: 'Hay algunos campos que debes llenar, por favor verifica e intenta nuevamente',
              close: 'Entiendo'
            },
            name: {
              label: '¿Cómo te llamas? *',
              placeholder: 'Escribe tu nombre',
              value: ''
            },
            email: {
              label: '¿Cuál es tu email? *',
              placeholder: 'Escribe tu email',
              value: ''
            },
            phone: {
              label: '¿Cuál es tu teléfono?',
              placeholder: 'Escribe tu número',
              value: ''
            },
            type: {
              label: '¿Qué consulta te interesa? *',
              placeholder: 'Elige el tipo de consulta',
              selectOptions: [
                'Ortografía Cerebral',
                'Desbloqueo emocional y financiero',
                'Lectura del inconsciente y alineación cerebral con cuarzos'
              ],
              value: ''
            },
            day: {
              label: '¿Qué día? *',
              placeholder: 'Selecciona',
              date: new Date(),
              config: {
                wrap: true, // set wrap to true only when using 'input-group'
                altFormat: 'M	j, Y',
                altInput: true,
                dateFormat: 'd-m-y',
                minDate: 'today',
                disable: [
                  function(date) {                  
                    return (date.getDay() === 0 || date.getDay() === 1 || date.getDay() === 5 || date.getDay() === 6)
                  }
                ],
                locale: Spanish
              },
              value: ''
            },
            message: {
              label: '¿Tienes algún comentario?',
              placeholder: 'Escribenos un comentario',
              value: ''
            },
            button: {
              text: 'Agendar Consulta',
              showLoading: false
            }
          }
          
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/landing/Appointments.vue